import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
`;

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const ControladoBadge = styled.span`
  display: inline-block;
`;
